<template>
    
</template>

<script>
    import BlogPostListComponent from "../../components/pagesbuilder/dynamic-components/BlogPostListComponent";
    import PreviewComponent from "./PreviewComponent";
    import {mapState} from "vuex";

    export default {
        name: "PreviewBlogPostListComponent",
        mixins: [
            PreviewComponent,
            BlogPostListComponent
        ],
        computed: {
            ...mapState('blog', [
                'fetchingBlogPostsPage'
            ]),
        },
        methods: {
            addListeners() {
                const loadMoreButton = this.componentNode.querySelector('.js-load-more-button');

                if (loadMoreButton) {
                    loadMoreButton.addEventListener('click', (e) => {
                        if (!this.getBlogPostPaginatedRequestInProgress) {
                            // Load more articles
                            this.setRows({value: this.myData.rows + 1});
                        }
                    });
                }

                const cards = this.componentNode.querySelectorAll(".js-component-card");
                for (let index in cards) {
                    if (!cards.hasOwnProperty(index)) {
                        continue;
                    }

                    let card = cards[index];
                    card.addEventListener("click", () => {
                        document.location.href = "/blog/" + card.getAttribute("data-title-id");
                    })
                }
            },
        }    
    }
</script>

